import React from 'react';
import { Button } from './Button';
import { CheckIcon } from 'lucide-react';
export interface PricingCardProps {
  name: string;
  price?: string;
  calls?: string;
  minutes?: string;
  target: string;
  inclusions: string[];
  ctaText: string;
  ctaLink?: string;
  isPopular?: boolean;
  isCustom?: boolean;
}
export function PricingCard({
  name,
  price,
  calls,
  minutes,
  target,
  inclusions,
  ctaText,
  ctaLink,
  isPopular = false,
  isCustom = false
}: PricingCardProps) {
  return <div className={`bg-[#252525] rounded-2xl p-10 border transition-all duration-300 hover:-translate-y-1 relative flex flex-col h-full ${isPopular ? 'border-[#F1B530] shadow-[0_0_40px_rgba(241,181,48,0.15)]' : 'border-[#2A2A2A] hover:border-[#F1B530]/30'}`} data-id="element-196">
      {isPopular && <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-[#F1B530] text-[#0F0F0F] px-6 py-2 rounded-full font-['Inter'] font-semibold text-sm" data-id="element-197">
          Most Popular
        </div>}

      <div className="mb-8" data-id="element-198">
        <h3 className="font-['Poppins'] font-bold text-2xl text-[#F5F5F5] mb-3" data-id="element-199">
          {name}
        </h3>
        {!isCustom ? <>
            <div className="mb-3" data-id="element-200">
              <span className="font-['Poppins'] font-bold text-5xl text-[#F5F5F5]" data-id="element-201">
                {price}
              </span>
              <span className="text-[#A0A0A0] font-['Inter'] ml-2 text-sm" data-id="element-202">
                plus GST/month
              </span>
            </div>
            <p className="text-[#A0A0A0] font-['Inter'] text-sm mb-2 font-light" data-id="element-203">
              Up to {calls} • {minutes} free minutes
            </p>
          </> : <div className="mb-3" data-id="element-204">
            <span className="font-['Poppins'] font-bold text-4xl text-[#F5F5F5]" data-id="element-205">
              Custom Pricing
            </span>
          </div>}
        <p className="text-[#A0A0A0] font-['Inter'] text-sm italic font-light" data-id="element-206">
          {target}
        </p>
      </div>

      <div className="mb-10 flex-grow" data-id="element-207">
        <ul className="space-y-4" data-id="element-208">
          {inclusions.map((inclusion, index) => <li key={index} className="flex items-start" data-id="element-209">
              <CheckIcon className="w-5 h-5 text-[#F1B530] mr-3 flex-shrink-0 mt-0.5" data-id="element-210" />
              <span className="font-['Inter'] text-[#F5F5F5] text-sm leading-relaxed font-light" data-id="element-211">
                {inclusion}
              </span>
            </li>)}
        </ul>
      </div>

      <div className="mt-auto" data-id="element-212">
        <Button className="w-full" size="lg" data-id="element-213">
          {ctaText}
        </Button>

        {ctaLink && <a href="#" className="block text-center mt-5 text-[#A0A0A0] font-['Inter'] text-sm hover:text-[#F1B530] transition-colors duration-300" data-id="element-214">
            {ctaLink}
          </a>}
      </div>
    </div>;
}